var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0146 2.38322L7.41097 5.76644C6.53305 6.59068 7.15483 8 8.39641 8H15.6036C16.8452 8 17.467 6.59068 16.589 5.76644L12.9854 2.38322C12.4412 1.87226 11.5588 1.87226 11.0146 2.38322Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58565 10.5315C8.38668 10.2828 8.05231 10.1868 7.75174 10.2923C7.45118 10.3977 7.25 10.6815 7.25 11V21C7.25 21.4142 7.58579 21.75 8 21.75C8.41421 21.75 8.75 21.4142 8.75 21V13.1381L15.4143 21.4685C15.6133 21.7172 15.9477 21.8132 16.2483 21.7077C16.5488 21.6023 16.75 21.3185 16.75 21V11C16.75 10.5858 16.4142 10.25 16 10.25C15.5858 10.25 15.25 10.5858 15.25 11V18.8619L8.58565 10.5315Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorth);
export default __webpack_public_path__ + "static/media/north.97b310f96383844a119aad9787a28109.svg";
export { ForwardRef as ReactComponent };